/* @flow */

import { connect } from 'react-redux';
import styled from '@emotion/styled';
import moment from 'moment';

const Cell = styled.div(({ important, highlight, separate, theme }) => ({
  alignItems: 'center',
  borderRight: separate ? '1px solid #ececec' : 0,
  borderBottom: '1px solid #ececec',
  display: 'flex',
  fontWeight: highlight && theme.fontWeight.bold,
  color: highlight && theme.color.widgetPrimary,
  justifyContent: 'center',
  padding: '0 0.5em',
  textTransform: important ? 'uppercase' : 'initial',
  whiteSpace: 'nowrap'
}));

const connector = connect((state, ownProps) => {
  const { columnIndex, style, game, categories, isRacing } = ownProps;

  const colOffset = isRacing ? 1 : 3;

  if (columnIndex === 0) {
    return {
      children: moment(game.startTime).format('DD MMM'),
      style
    };
  }

  if (!isRacing) {
    if (columnIndex === 1) {
      const prefix = game.isHome ? '' : '@';
      return {
        children: `${prefix}${game.oppositionAbbr}`,
        important: true,
        style
      };
    }

    if (columnIndex === 2) {
      return {
        children: game.score,
        highlight: true,
        separate: true,
        style
      };
    }
  }

  const statKey = categories[columnIndex - colOffset].id;

  return {
    children: game.stats[statKey] || '–',
    style
  };
}, {});

export default connector(Cell);
